import SupplementaryAccount from '@/types/purchaseRequest/suplementaryAccount'
import { BaseService } from './../../base'
export class SupplementaryAccountService extends BaseService<SupplementaryAccount>() {
    static get entity (): string {
        return 'suplementary_account'
    }
    static get responseName (): string {
        return 'suplementary_account'
    }
}